import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M18 .053V31.95a61 61 0 0 1-2 .05 57 57 0 0 1-2-.053V.053c.662-.03 1.332-.047 2-.053.668.006 1.338.023 2 .053",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.033 14h31.938q.04 1.034.026 2.016.013.964-.03 1.984H.029a38 38 0 0 1-.026-2.017c-.008-.64.001-1.304.03-1.983",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "#D9D9D9", d: "m13.944 11.86 2.04-.365 2.126.366-.986.41-1.82.03z" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M16 8.128A.564.564 0 1 0 16 7a.564.564 0 0 0 0 1.128",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "M18.512 10.324c.93-1.07 1.034-2.073.224-2.618-.33-.221-.804-.26-1.49-.196-.154.014-.308.032-.514.059-.589.077-.614.08-.736.08-.12 0-.141-.003-.732-.08a13 13 0 0 0-.518-.06c-.683-.062-1.156-.024-1.485.197-.81.545-.705 1.548.224 2.618l.222.256.51-.444-.22-.255c-.698-.804-.755-1.346-.359-1.613.155-.104.515-.133 1.047-.085.144.014.291.03.49.057.654.086.654.086.82.086.169 0 .175-.001.824-.086.199-.026.345-.043.489-.056.534-.05.895-.02 1.05.084.397.267.34.809-.357 1.613l-.222.255.511.444z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      d: "M18.384 10.214c.871-1.005.964-1.892.257-2.367-.286-.193-.732-.228-1.38-.169a13 13 0 0 0-.508.059c-.603.079-.624.081-.757.081-.132 0-.148-.002-.754-.081a13 13 0 0 0-.512-.06c-.645-.058-1.09-.022-1.375.17-.707.475-.614 1.362.257 2.366l.111.128.256-.221-.111-.128c-.755-.87-.824-1.528-.324-1.864.198-.134.586-.165 1.156-.113.147.013.296.03.498.057.637.084.642.084.798.084s.167 0 .801-.084c.2-.026.349-.043.495-.057.572-.052.962-.021 1.16.113.5.336.432.993-.324 1.864l-.11.127.255.222z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M13.461 9.82S14.072 8.696 16 8.693c1.927-.002 2.538 1.129 2.538 1.129v1.692h-5.077z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m13.461 9.82.847 1.129.394-1.41.734 1.128L16 9.309l.564 1.358.733-1.129.395 1.41.846-1.127v2.256h-5.077z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#D9D9D9",
      fillRule: "evenodd",
      d: "M16 12.641c1.402 0 2.538-.252 2.538-.564s-1.136-.564-2.538-.564-2.539.252-2.539.564 1.137.564 2.539.564",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M15.83 8.025v1.213a.17.17 0 1 0 .339 0V8.025a.17.17 0 1 0-.338 0" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m13.64 16-1.104-2 2.284-.044L16 12l1.18 1.956 2.284.044-1.104 2 1.104 2-2.284.044L16 20l-1.18-1.956L12.536 18z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M16.748 16.866c.095-.094.247-.198.332-.424.08-.212.118-.6.19-.797.095-.337.285-.666.058-.643-.215.021-.285.23-.367.384-.038.058-.125.18-.142.25-.003-.117-.062-.458-.074-.8-.01-.32-.002-.654-.01-.778-.01-.164-.01-.318-.048-.44-.018-.056-.1-.11-.143-.108-.087 0-.14.076-.15.148-.01.057-.007.036-.013.109-.007.092.002.212-.005.316-.007.113.008.238.002.343a9 9 0 0 1-.034.445c0-.078-.036-.449-.047-.8l-.01-.388c-.002-.1.002-.205-.008-.282-.019-.131-.06-.19-.155-.19-.064 0-.156.046-.185.192a1.3 1.3 0 0 0-.014.28c.003.098.008.204.006.31-.006.4-.013.825-.029.95-.003-.04-.042-.25-.053-.531l-.016-.372c-.007-.152-.007-.266-.01-.368-.002-.061-.026-.238-.143-.228-.062-.007-.127.036-.154.203-.014.094-.014.254-.017.378-.004.235-.014.44-.003.65.007.13.006.23.007.295a1.4 1.4 0 0 1-.05-.282c-.017-.169-.032-.383-.031-.334 0-.086-.004-.216-.012-.323-.006-.083-.002-.175-.092-.168-.092.008-.148.039-.166.196-.013.102-.016.322-.019.402a5.5 5.5 0 0 1-.068.81c-.007.096-.044.22-.06.353a2.7 2.7 0 0 0 .036.793c.075.27.27.392.26.576s0 .508 0 .653.125.153.384.096c.424-.091.656.092 1.006-.043-.045-.401.042-.643.04-.788z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagGbNir = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagGbNir_default = SvgFlagGbNir;

export { FlagGbNir_default as default };
